import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAgentActiveCurrency } from "../redux/slice/userSlice";
import {
  getCurrencyList,
  getActiveCode,
  getCurrencyMeta,
  setActiveCurrency,
} from "../helper/currencyState";
import { ChevronDownIcon, NetworkIcon } from "../helper/HwIcon";

const CurrencyGlyph = ({ code }) => {
  const m = getCurrencyMeta(code);
  return m.iconClass ? (
    <span className={m.iconClass}>{m.glyph}</span>
  ) : (
    <span className="hw-currency-symbol">{m.symbol || code}</span>
  );
};

const CurrencySwitcher = () => {
  const dispatch = useDispatch();
  const { agentActiveCurrency } = useSelector((state) => state.userData);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const list = getCurrencyList();

  useEffect(() => {
    const restored = getActiveCode();
    if (restored && restored !== agentActiveCurrency) {
      dispatch(setAgentActiveCurrency(restored));
    }
  }, []);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const select = (code) => {
    setActiveCurrency(code);                 // module: cookie + active rate
    dispatch(setAgentActiveCurrency(code));  // redux: re-render prices everywhere
    setOpen(false);
  };

  const active = agentActiveCurrency || getActiveCode();

  const getFlagbyCode = (code) => {
    return list?.find(cur => cur?.code === code)?.flag
  }

  return (
    <div className="hw-currency-switch" ref={ref}>
      <button
        type="button"
        className="hw-currency-switch__btn"
        onClick={() => setOpen((o) => !o)}
      >
        <img src={getFlagbyCode(active)} width={32} height={24} />
        <div className="d-flex">
          <span className="hw-currency-switch__code">{active}</span>
          <span className={`hw-currency-switch__caret${open ? " is-open" : ""}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="#3264FF" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </button>
      {open && (
        <ul className="hw-currency-switch__menu">
          {list.map((c) => (
            <li
              key={c.code}
              className={`hw-currency-switch__item${c.code === active ? " is-active" : ""}`}
              onClick={() => select(c.code)}
            >
              <img src={c?.flag} width={32} height={24} />
              <span className="hw-currency-switch__code">{c.code}</span>
              {/* <span className="hw-currency-switch__name">{c.name}</span> */}
              {/* <span className="hw-currency-switch__name">{c.name}</span> */}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CurrencySwitcher;
